import index from "./legalList.vue";
export default index;
